'use strict';
const angular = require('angular');

import { IMessagesService, IMessage } from '../../interfaces';

export const MODULE_BASKETS = 'baskets';

const BASKETS_AFTER_CREATION = 'afterCreation';
const BASKETS_AFTER_ACTIVATE = 'afterActivate';
const BASKETS_AFTER_PAYMENT = 'afterPayment';
export const BASKETS_PAYMENT_REMINDER = 'paymentReminder';

export class Action {
  name: string;
  label: string;

  constructor(name, label) {
    this.name = name;
    this.label = label;
  }
}

/*@ngInject*/
export class MessagesService implements IMessagesService {
  
  $http: ng.IHttpService;
  deferred: ng.IDeferred<any>;
  $q: ng.IQService;

  basketMessages: IMessage[] = [];

  basketActions: Action[] = [];

  /*@ngInject*/
  constructor($http) {
    this.$http = $http;

    //Building baskets actions
    this.basketActions.push(new Action(BASKETS_AFTER_CREATION, 'After creation'));
    this.basketActions.push(new Action(BASKETS_AFTER_ACTIVATE, 'After activate'));
    this.basketActions.push(new Action(BASKETS_AFTER_PAYMENT, 'After payment'));
    this.basketActions.push(new Action(BASKETS_PAYMENT_REMINDER, 'Payment reminder'));

    this.reload();
  }

  // Reload all basket messages
  public reload() {
    this.$http.get("/api/messages/" +MODULE_BASKETS)
    .then((res) => {
      this.basketMessages = res.data as IMessage[];
    });
  }

  public getBasketActions() {
    return this.basketActions;
  }

  public getBasketMessage(action) {
    let message: IMessage;
    
    let msgsFound: IMessage[] = this.basketMessages.filter(m => m.action===action.name);
    if (msgsFound.length > 0) {
      message = msgsFound[0];

    } else {
      message = {
        _id: null,
        module: MODULE_BASKETS,
        action: action.name,
        subject: "",
        text: "",
        enable: false
      };
    }

    return message;
  }

  public setBasketMessage(message: IMessage) {
    if (message._id && message._id != null && message._id!=="") {
      return this.$http.put('/api/messages/' +message._id, message)
      .then(() => {
        this.reload();
      });

    } else {
      return this.$http.post('/api/messages/', message)
      .then(() => {
        this.reload();
      });
    }
  }

  public sendMail(message: IMessage, memberships, extraEmails) {
    return this.$http.post('/api/messages/send/' +message._id, {memberships: memberships, extraEmails})
    .then(() => {
      this.reload();
    });
  }
}

export default angular.module('terrappApp.MessagesService', [])
  .service('MessagesService', MessagesService)
  .name;



// WEBPACK FOOTER //
// ./client/app/services/messagesService/messagesService.service.ts